require('./filter-tree.scss')

import angular from 'angular';

import Trees from '../../models/trees';
import FactQuery from '../../models/fact-query';

import FilterTreeDirective from './filter-tree.directive';

export default angular.module('directives.lf-filter-tree', [
    Trees, FactQuery
  ])
  .run(['$templateCache', ($templateCache) => {
    $templateCache.put('/filter-tree/node.html', require('./node.html'));
  }])
  .directive('lfFilterTree', FilterTreeDirective)
  .name;



// WEBPACK FOOTER //
// ./project/directives/lf-filter-tree/index.js